// Masks keystrokes into MM/DD/YYYY, refusing impossible months (> 12) and days (> 31).
// The server still validates the completed date.
const MAXES = ["12", "31"]; // Month, day; the year is left open.

export function maskDate(value) {
  const done = []; // Completed segments.
  let current = ""; // Digits of the segment in progress (never more than one until it closes).
  let seg = 0; // 0 = month, 1 = day, 2 = year.
  let separator = false; // Whether the visitor has parked a "/" after the last segment.

  for (const char of value) {
    if (char < "0" || char > "9") {
      // A non-digit acts as a separator, closing the current segment.
      if (current && seg < 2) {
        if (current === "0") continue; // "0" alone is not a valid month or day.
        done.push("0" + current); // Pad the single digit, e.g. "1" → "01".
        current = "";
        seg += 1;
        separator = true;
      } else if (!current && done.length && seg <= 2) {
        separator = true; // A separator sitting right after a completed segment.
      }
      continue;
    }

    if (seg > 2) continue; // Nothing comes after the year.

    separator = false;

    if (seg === 2) {
      current += char;
      if (current.length === 4) {
        done.push(current);
        current = "";
        seg += 1;
      }
      continue;
    }

    const max = MAXES[seg];
    if (!current) {
      if (char > max[0]) {
        done.push("0" + char); // e.g. month 3 → 03, day 5 → 05: only one value fits.
        seg += 1;
      } else {
        current = char; // Still ambiguous — wait for the second digit.
      }
      continue;
    }

    const pair = current + char;
    if (pair !== "00" && pair <= max) {
      done.push(pair);
      current = "";
      seg += 1;
    } // else refuse the second digit that would break the range.
  }

  let out = done.join("/");
  if (current) out += (done.length ? "/" : "") + current;
  else if (separator && done.length) out += "/";

  return out;
}
